'use client'

import { useState, useEffect, useCallback } from 'react'

import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { viewScreenEvent } from '@marketplace-web/messaging/conversation-user-data'

import BuyerDetailsModal from '../BuyerDetailsModal'

const BuyerDetailsLink = () => {
  const transactionId = useConversationContext().conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)
  const { track } = useTracking()

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true)
    track(viewScreenEvent({ screen: 'b2c_buyer_invoice_details' }))
  }, [track, setIsModalOpen])

  const handleClose = () => setIsModalOpen(false)

  useEffect(() => {
    const handleShipmentLinkClick = event => {
      const element = event.target as HTMLElement

      if (!element.classList.contains(ConversationLinkActions.BuyerDetailsLink)) return

      event.preventDefault()
      handleModalOpen()
    }

    document.body.addEventListener('click', handleShipmentLinkClick)

    return () => {
      document.body.removeEventListener('click', handleShipmentLinkClick)
    }
  }, [handleModalOpen])

  return (
    <BuyerDetailsModal isOpen={isModalOpen} onClose={handleClose} transactionId={transactionId} />
  )
}

export default BuyerDetailsLink
